import React, { useContext, useEffect, useMemo } from 'react'

import { DataContext } from '../../../explorer/map/DataContext'
import SubmissionsMapHeader from '../submissionsMap/SubmissionsMapHeader'
import ExplorerMap from '../../../explorer/map/ExplorerMap'
import { DataContext as SubmissionsDataContext } from '../../DataContext'
import { FacilityAssignmentContext as FacilityAssignmentDataContext } from '../facilityAssignment/DataContext'
import { AppStateContext } from '../../../explorer/AppStateContext'
import MapLayerControls from '../../../explorer/map/layers/MapLayerControls'
import VectorSource from 'ol/source/Vector'
import { transform } from 'ol/proj'
import Point from 'ol/geom/Point'
import Feature from 'ol/Feature'
import { getStyleFunction } from '../../../explorer/map/mapStyles'

export default () => {
    const {
        getFeatureWithLatLong,
        setIsSubmissionsMap,
        filteredData,
        setFilteredData,
        source,
        data,
    } = useContext(DataContext)
    const {
        mapState: { map },
    } = useContext(AppStateContext)
    const { activePanel } = useContext(SubmissionsDataContext)
    const { possibleFacilityData } = useContext(FacilityAssignmentDataContext)

    useEffect(() => setIsSubmissionsMap(true), [])

    useEffect(() => {
        if (
            possibleFacilityData &&
            possibleFacilityData.length &&
            activePanel === 'View in Map'
        ) {
            const facilities = possibleFacilityData
            const facilitiesToAdd = facilities.map(x => x.ClearinghouseNumber)
            setFilteredData(facilitiesToAdd)
            const primaryFacility = facilities.find(x => x.IsPrimary === true)
            if (primaryFacility) {
                getFeatureWithLatLong(
                    primaryFacility.Latitude,
                    primaryFacility.Longitude,
                    primaryFacility.ClearinghouseNumber,
                    true
                )
            }

            const allDataClearinghouseNumbers = new Set(
                data.features.map(x => x.properties.ClearinghouseNumber)
            )
            const missingFacilities = facilitiesToAdd.filter(
                id => !allDataClearinghouseNumbers.has(id)
            )

            if (!map || !source) return

            possibleFacilityData.forEach(f => {
                if (missingFacilities.includes(f.ClearinghouseNumber)) {
                    const featuresInXYCoords = transform(
                        [parseFloat(f.Longitude), parseFloat(f.Latitude)],
                        'EPSG:4326',
                        'EPSG:3857'
                    )
                    let point = new Point(featuresInXYCoords)
                    var feature = new Feature(point)
                    feature.set('displayed', 1)
                    feature.set('ClearinghouseNumber', f.ClearinghouseNumber)
                    feature.setStyle(feat => getStyleFunction(map, false, feat))
                    if (!source.hasFeature(feature)) {
                        source.addFeature(feature)
                    }
                }
            })

            const allFeatures = source.getFeatures()

            // Filter features where isdisplayed = 1
            const displayedFeatures = allFeatures.filter(feature => {
                const properties = feature.getProperties()
                return facilitiesToAdd.includes(properties.ClearinghouseNumber)
            })
            const filteredSource = new VectorSource({
                features: displayedFeatures,
            })

            map.updateSize()
            if (displayedFeatures.length > 0) {
                const extent = filteredSource.getExtent()
                map.getView().fit(extent, {
                    padding: [20, 40, 20, 40],
                    minResolution: 50,
                    duration: 500,
                })
            }
        }
    }, [possibleFacilityData, activePanel, data, source, map])

    return (
        <div className="mt-5">
            <div
                className={`${
                    activePanel === 'View in Map' ? '' : 'is-hidden'
                } `}
            >
                <SubmissionsMapHeader />
                <MapLayerControls mapMenu={`SubmissionsMap`} />
                <ExplorerMap />
            </div>
        </div>
    )
}
